import React, { useState, useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  colors,
  useTheme
} from '@material-ui/core';
import LineIcon from 'react-lineicons';

const WebDeviceVisitor = (props) => {
  const [devnum1, setDevnum1] = useState(0);
  const [devnum2, setDevnum2] = useState(0);
  const [devnum3, setDevnum3] = useState(0);
  const [devn1, setDevn1] = useState('');
  const [devn2, setDevn2] = useState('');
  const [devn3, setDevn3] = useState('');
  const theme = useTheme();

  useEffect(() => {
    const url = 'https://us-central1-zaini-57782.cloudfunctions.net/bengkel/gadevice';

    fetch(url)
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        throw res;
      })
      .then((data) => {
        setDevnum1(parseInt(data.rows[0].metricValues[0].value, 10));
        setDevnum2(parseInt(data.rows[1].metricValues[0].value, 10));
        setDevnum3(parseInt(data.rows[2].metricValues[0].value, 10));
        setDevn1(data.rows[0].dimensionValues[0].value);
        setDevn2(data.rows[1].dimensionValues[0].value);
        setDevn3(data.rows[2].dimensionValues[0].value);
        // console.log(data.feed.entry);
      });
  }, []);

  const data = {
    datasets: [
      {
        data: [devnum1, devnum2, devnum3],
        backgroundColor: [
          colors.indigo[500],
          colors.red[600],
          colors.orange[600]
        ],
        borderWidth: 8,
        borderColor: colors.common.white,
        hoverBorderColor: colors.common.white
      }
    ],
    labels: [devn1, devn2, devn3]
  };

  const options = {
    animation: false,
    cutoutPercentage: 80,
    layout: { padding: 0 },
    legend: {
      display: false
    },
    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      backgroundColor: theme.palette.background.paper,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: 'index',
      titleFontColor: theme.palette.text.primary
    }
  };

  const devices = [
    {
      title: devn1,
      value: devnum1,
      color: colors.indigo[500]
    },
    {
      title: devn2,
      value: devnum2,
      color: colors.red[600]
    },
    {
      title: devn3,
      value: devnum3,
      color: colors.orange[600]
    }
  ];

  return (
    <Card {...props}>
      <CardHeader
        avatar={<LineIcon name="chrome" />}
        title="Device Pengunjung Web 7D"
      />
      <Divider />
      <CardContent>
        <Box
          sx={{
            height: 300,
            position: 'relative'
          }}
        >
          <Doughnut
            data={data}
            options={options}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            pt: 2
          }}
        >
          {devices.map(({
            color,
            title,
            value
          }) => ((
            <Box
              key={color + title}
              sx={{
                p: 1,
                textAlign: 'center'
              }}
            >

              <Typography
                color="textPrimary"
                variant="body1"
              >
                {title}
              </Typography>
              <Typography
                style={{ color }}
                variant="h2"
              >
                {value}
              </Typography>
            </Box>
          )
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default WebDeviceVisitor;
